import React from 'react';
import Chat from './Chat';
import WelcomeCard from './WelcomeCard';
import useChatStore from './useChatStore';

function DocChat({ course }) {
  const { messages } = useChatStore();

  return (
    <div className="h-full overflow-hidden">
      {messages.length > 1 ? <Chat course={course} /> : <WelcomeCard course={course} />}
    </div>
  );
}

export default React.memo(DocChat);
